import {
  FETCH_PAYMENT_DATA_FAILURE,
  FETCH_PAYMENT_DATA_REQUEST,
  FETCH_PAYMENT_DATA_SUCCESS,
} from '@/actionTypes';
import { config } from '@/config';
import {
  getFormattedRouterMatchParams,
  getPaymentDataIsFetching,
} from '@/selectors';
import { formatAmount } from '@/utils';

import { getLead, sendNote } from '../../server/api';

const shouldFetch = state => {
  const isFetching = getPaymentDataIsFetching(state);

  return !isFetching;
};

export const fetchPayment = props => async (dispatch, getState) => {
  const { projectVars: { APP_PROJECT, APP_PUBLIC_URL_ORIGIN } = {} } = props;
  const currentState = getState();

  const {
    crmLeadId,
    dgoCrmLeadId,
    orderNumber,
  } = getFormattedRouterMatchParams(currentState, props);

  if (!shouldFetch(currentState)) {
    return true;
  }

  dispatch({
    type: FETCH_PAYMENT_DATA_REQUEST,
  });

  const requestData = {
    lead_id: +crmLeadId,
    ...(dgoCrmLeadId ? { dgo_lead_id: +dgoCrmLeadId } : {}),
    order_number: orderNumber,
    client: config.amoClient,
    resource: APP_PROJECT,
  };

  const defaultPayload = {
    crmLeadId,
    dgoCrmLeadId,
    orderNumber,
    project: APP_PROJECT,
    deployUrl: APP_PUBLIC_URL_ORIGIN,
  };

  try {
    const response = await getLead(requestData);
    const {
      data: { firstName, lastName, payment, paymentDgo },
    } = response;
    const amountValue = paymentDgo
      ? Number(payment) + Number(paymentDgo)
      : payment;
    const amount = formatAmount(amountValue);

    return dispatch({
      type: FETCH_PAYMENT_DATA_SUCCESS,
      payload: {
        ...defaultPayload,
        customerFullName: `${lastName || ''} ${firstName || ''}`,
        amount,
      },
    });
  } catch (error) {
    const errorData = error.response?.data || {};
    const errorMessage = errorData?.message || errorData?.messages;

    if (errorMessage) {
      // eslint-disable-next-line
      console.error(
        `Fetch lead ${crmLeadId}-${orderNumber} data error: `,
        errorMessage
      );
    }
    const noteData = {
      lead_id: Number(crmLeadId),
      client: config.amoClient,
      resource: APP_PROJECT,
      note: `⚠️ Возникла ошибка при получении даных лида::\n'message': ${errorMessage}`,
      error: true,
    };

    try {
      await sendNote(noteData);

      if (dgoCrmLeadId) {
        await sendNote({ ...noteData, lead_id: Number(dgoCrmLeadId) });
      }
    } catch (e) {
      console.warn('Error sending note to amo', e.response?.data || e.message);
    }

    return dispatch({
      type: FETCH_PAYMENT_DATA_FAILURE,
      payload: {
        ...defaultPayload,
      },
    });
  }
};

export default fetchPayment;
